import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import Box from "react-raster";

export const getGridBottomFromContent = (bottomSpacing) => {
  if (bottomSpacing === "small") {
    return "20px";
  }
  if (bottomSpacing === "medium") {
    return "40px";
  }
  return "100px";
};

export const ContainerWrapper = styled.section`
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: ${({ $hasBottomMargin }) => $hasBottomMargin && "0px"};
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};

  @media (${({ theme }) => theme.mq.m}) {
    max-width: ${({ theme, $isFluid }) =>
      $isFluid ? "100%" : `${theme.breakpoints[2]}px`};
  }

  @media (${({ theme }) => theme.mq.l}) {
    max-width: ${({ theme, $isFluid }) =>
      $isFluid ? "100%" : `${theme.breakpoints[3]}px`};
  }
`;

function Container({
  children,
  id,
  as,
  isFluid,
  backgroundColour,
  style,
  hasBottomMargin = true,
  ...others
}) {
  const themeContext = useContext(ThemeContext);
  const { breakpoints, containerPadding, gridColumnGap, gridRowGap } =
    themeContext;

  return (
    <ContainerWrapper
      style={style}
      as={as}
      id={id}
      $isFluid={isFluid}
      $backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
    >
      <Box
        colspan={[6, 12]}
        breakpoints={breakpoints}
        paddingLeft={isFluid ? 0 : containerPadding}
        paddingRight={isFluid ? 0 : containerPadding}
        gridColumnGap={gridColumnGap}
        gridRowGap={gridRowGap}
        control={process.env.NODE_ENV !== "production"}
        {...others}
      >
        {children}
      </Box>
    </ContainerWrapper>
  );
}

export default Container;
